import React, { memo, useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import InfoPageLink from '../../../../components/info-page-link';
import { StoreStatistics } from 'src/types';
import { StyledInfoPageLink, StyledPriceInformation } from './styles';

const PriceInformation: React.FC<IPriceInformationProps> = props => {
  const { t, market } = useContext(AppContext);

  if (!market.modules?.priceInfo?.enabled) {
    return null;
  }

  return (
    <StyledPriceInformation>
      <div>
        {t('product', 'price-comparison-information.featured-stores-ratio', {
          totalCount: props.storeStatistics?.totalCount || 0,
          featuredCount: props.storeStatistics?.featuredCount || 0,
        })}
        <br />
        {t('product', 'price-comparison-information.listed-stores-information')}
      </div>
      <StyledInfoPageLink>
        <InfoPageLink id={market.infoPageMap?.priceInformation}>
          {t('product', 'price-comparison-information.read-more')}
        </InfoPageLink>
      </StyledInfoPageLink>
    </StyledPriceInformation>
  );
};

interface IPriceInformationProps {
  storeStatistics: StoreStatistics;
}

export default memo(PriceInformation);
